import React, { useState, useEffect } from "react";
import { Button } from "theme-ui";
import Parser from "html-react-parser";
import cssToJS from "transform-css-to-js";
import { displayError } from "sites-common/utils/customErrors";
import { validateRE } from "sites-common/utils/validations";
import PackageComp from "../ListOfTrees";
import DonationComponent, {
  clickDonateBtn,
  loadDonateSuccessPage,
} from "../DonationComponent";
import { RegFormModal } from "../ui";
import "../../i18n";

export const eventCallbackConstants = { clickDonateBtn, loadDonateSuccessPage };
const getMandatoryEnv = require("sites-common/utils/getMandatoryEnv");

const { domainDonations } = getMandatoryEnv(["domainDonations"]);

const isBrowser = () => typeof window !== "undefined";

const replaceImgSrc = (media, imgSrc) => {
  const image = media.find((n) => {
    return n.node.source_url.includes(imgSrc);
  });
  return image;
};

function none() {
  return null;
}

const noop = () => {};
function isObject(obj) {
  return obj !== undefined && obj !== null && obj.constructor === Object;
}

function getHexColor(colorStr) {
  if (isBrowser()) {
    const a = document.createElement("div");
    a.style.color = colorStr;
    const colors = window
      .getComputedStyle(document.body.appendChild(a))
      .color.match(/\d+/g)
      .map((a1) => parseInt(a1, 10));
    document.body.removeChild(a);
    return colors.length >= 3
      ? `#${((1 << 24) + (colors[0] << 16) + (colors[1] << 8) + colors[2])
          .toString(16)
          .substr(1)}`
      : false;
  }
  return "~~~~~~";
}

const colorString = (p) => {
  const colorKeys = [
    "background",
    "text",
    "primary",
    "secondary",
    "errortext",
    "errorbg",
    "muted",
    "highlight",
    "background2",
  ];
  const l = colorKeys
    .map((c) =>
      (validateRE("#[0-9a-fA-F]{6}", p[`color${c}`])
        ? p[`color${c}`]
        : getHexColor(p[`color${c}`])
      ).replace("#", "")
    )
    .join(":");

  if (l.includes("~~~~~~")) {
    return "";
  }
  return l;
};

export function PageContentNonMemoized({
  pageContent,
  mediaEdges = [],
  pressreleaseContent = JSON.stringify(""),
  packageData = JSON.stringify(""),
  PressRelease = none,
  SocialIcon = none,
  eventCallback = noop,
}) {
  const [packageQty, setPackageQty] = useState("");
  const [trees, setTrees] = useState("");
  const [soure, setSource] = useState("");

  const defaultCurrency = "INR";
  const packageLayouts =
    packageData &&
    (isObject(packageData) ? packageData : JSON.parse(packageData));

  const packageTreeOptions = (packageData && packageLayouts.treePackage) || "";

  // useEffect(() => {
  //   setPackageQty("");
  //   setTrees("");
  // }, [setPackageQty, setTrees]);

  useEffect(() => {
    const soureText = localStorage.getItem("source");
    setSource(soureText);
  }, []);

  const handleTreeFieldChange = (
    quantity,
    selectedPack,
    selectedTree,
    treeCheck
  ) => {
    setPackageQty(quantity);
    if (treeCheck.length >= 1) {
      setTrees(treeCheck);
    } else {
      setTrees(selectedTree);
    }
    if (selectedPack) {
      setPackageQty(selectedPack.qty);

      const treeDescription = selectedPack.desc;
      if (treeDescription.length > 0) {
        setTrees(selectedPack.desc);
      } else if (treeDescription.length <= 0) {
        setTrees(selectedPack.title);
      }
    }
  };

  return Parser(pageContent, {
    replace: (d) => {
      const domNode = { ...d };
      if (domNode.name === "div" && domNode.attribs.class === "banner-gatsby") {
        const image = replaceImgSrc(mediaEdges, domNode.attribs["data-src"]);
        domNode.attribs.style = `${domNode.attribs.style} ;background-Image: url('${image.node.localFile.publicURL}')`;
      }
      if (domNode.name === "img") {
        const image = replaceImgSrc(mediaEdges, domNode.attribs.src);
        if (image) {
          const imgSrc = image.node.localFile
            ? image.node.localFile.publicURL
            : image.node.source_url;
          const altName = image.node.localFile
            ? image.node.localFile.name
            : "no img";
          return <img src={imgSrc} alt={altName} className="img-fluid" />;
        }
        return <img src="" alt="no-img" />;
      }
      if (domNode.name === "gatsby_regform") {
        const params = { ...domNode.attribs };
        Object.assign(params, {
          registerVia: "emailOrMobile",

          missedCallDetails: {
            text: "Give a missed call to: ",
            teleNumber: "+918939589295",
            displayNumber: "+91-89395-89295",
            show: true,
          },

          validateEmail: async (email) =>
            displayError(`validate email: ${email}`),

          validateContactNumber: async (contactNumber) =>
            displayError(`validate contact number: ${contactNumber}`),

          onSubmit: async (formData) =>
            displayError(JSON.stringify(formData, null, 2)),

          // Pass a customized Modal-Open button here:
          Trigger: (props) => (
            <Button
              variant="variant1"
              sx={{
                bg: "rebeccapurple",
                cursor: "pointer",
              }}
              {...props}
            >
              Register Today!!
            </Button>
          ),
        });

        return <RegFormModal {...params} />;
      }
      if (domNode.name === "gatsby_donation") {
        const p = domNode.attribs;
        const {
          donationid,
          amount,
          projectid,
          btntext,
          btnbg,
          btnstyle = "margin:2px;margin-left:auto;margin-right:auto;width:auto;border-radius:25px;padding-left:25px;padding-right:25px;",
          btnstylehover = "opacity: 0.9;",
          colortext = "black",
          colorprimary = "forestgreen",
          colorsecondary = "darkgreen",
          colorbackground = "white",
          colormuted = "#f6f6f6",
          colorhighlight = "#efeffe",
          colorerrorbg = "#fff",
          colorerrortext = "#D82727",
          colorbackground2 = "#f0f0f0",
          titletext = "Heartfulness Green",
          rate = 1,
          showinput = false,
          layoutstyle = "display:flex;padding:8px;",
          nomodal = false,
          currency,
          enablesigninoption = 1,
          removeaccounttype: removeAccountType,
          meditationplacefieldavl: meditationPlaceFieldAvl,
          classname = "",
        } = p;

        const css = `btnstyle { ${btnstyle} } btnstylehover { ${btnstylehover} }`;
        const x = JSON.parse(
          eval(eval(`\`var obj = ${cssToJS(css, true)}; JSON.stringify(obj)\``))
        );
        const css1 = `layoutstyle { ${layoutstyle} }`;
        const x1 = JSON.parse(
          eval(
            eval(`\`var obj = ${cssToJS(css1, true)}; JSON.stringify(obj)\``)
          )
        );

        const btnStyle = {
          backgroundColor: btnbg,
          ...x.btnstyleElement,
          "&:hover": {
            ...x.btnstylehoverElement,
          },
        };

        const layoutStyle = {
          ...x1.layoutstyleElement,
        };

        const colorCodes = {
          colortext,
          colorprimary,
          colorsecondary,
          colorbackground,
          colorhighlight,
          colorbackground2,
          colormuted,
        };

        let failureReturnUrl = `${domainDonations}/embedded/${donationid}/${colorString(
          {
            colorerrorbg,
            colorerrortext,
            ...colorCodes,
          }
        )}/${titletext}/${projectid}`;

        let successReturnUrl = `${domainDonations}/embedded/${donationid}/${colorString(
          {
            colorerrorbg: colorbackground2,
            colorerrortext: colorsecondary,
            ...colorCodes,
          }
        )}/${titletext}/${projectid}`;

        if (soure) {
          const furl = new URL(failureReturnUrl);
          furl.searchParams.set("source", soure);

          const surl = new URL(successReturnUrl);
          surl.searchParams.set("source", soure);

          failureReturnUrl = furl.href;
          successReturnUrl = surl.href;
        }

        return (
          <DonationComponent
            colors={{
              text: colortext,
              primary: colorprimary,
              secondary: colorsecondary,
              muted: colormuted,
              highlight: colorhighlight,
              background: colorbackground,
              errorbg: colorerrorbg,
              errortext: colorerrortext,
              background2: colorbackground2,
            }}
            layout="buttons"
            layoutProps={{
              ...(showinput
                ? { showOther: btntext, rate }
                : {
                    rate,
                    buttons: [
                      {
                        text: packageQty
                          ? `${
                              packageTreeOptions.currency || defaultCurrency
                            } ${packageQty * rate} - ${btntext}`
                          : btntext,
                        qty: packageQty || amount,
                      },
                    ],
                  }),
              btnStyle,
              layoutStyle,
            }}
            titleText={titletext}
            donationId={donationid}
            projectId={projectid}
            packageDescription={trees}
            eventCallback={eventCallback}
            noModal={!!nomodal}
            paymentSuccessUrl={successReturnUrl}
            paymentFailureUrl={failureReturnUrl}
            currency={currency}
            enableSignInOption={Boolean(parseInt(enablesigninoption, 10))}
            removeAccountType={removeAccountType === "true"}
            meditationPlaceFieldAvl={meditationPlaceFieldAvl === "true"}
            classname={classname}
          />
        );
      }
      if (domNode.name === "press_release") {
        const pressReleaseData = JSON.parse(pressreleaseContent);
        return <PressRelease htmlsrc={pressReleaseData} />;
      }
      if (domNode.name === "donation_package") {
        return (
          <PackageComp
            onHandleTreeFieldChange={handleTreeFieldChange}
            projects={packageTreeOptions}
            type={domNode.attribs.type}
          />
        );
      }
      if (domNode.name === "social_icon") {
        const iconType = domNode.attribs.type ? domNode.attribs.type : "";
        return <SocialIcon type={iconType} />;
      }
      return domNode;
    },
  });
}
